import React from "react";
import * as PropTypes from "prop-types";
import { Menu as AntdMenu } from "antd";
import ButtonDropdown from "./ButtonDropdown";
import styled from "styled-components";
import { UnorderedListOutlined } from "@ant-design/icons";
import _ from "lodash";
const groupBy = require("lodash/groupBy");

// Can't be a Pure Component due to Dropdown lookups overlay component type to set appropriate styles
const memberMenu = (onClick, grouped, intl) => {
  const sortedCategories = _.sortBy(Object.keys(grouped), [
    function (o) {
      return intl.formatMessage({
        id: `app.analytics.${o}`,
      });
    },
  ]);

  const items = sortedCategories.map((category) => ({
    key: category,
    // icon: <UnorderedListOutlined />,
    label: intl.formatMessage({
      id: `app.analytics.${category}`,
    }),
    children: _.sortBy(grouped[category], [
      function (k) {
        return intl.formatMessage({
          id: `app.analytics.${k.name}`,
        });
      },
    ]).map((m) => ({
      key: m.name,
      onClick: () => onClick(m),
      label: intl.formatMessage({
        id: `app.analytics.${m.name}`,
        defaultMessage: `${m.title}`,
      }),
    })),
  }));
  return items;
};

const MemberDropdown = ({
  onClick,
  availableMembers,
  intl,
  ...buttonProps
}) => {
  const membersWithSections = availableMembers.map((item, i) => ({
    ...item,
    section: item.name.substring(0, item.name.indexOf(".")),
  }));
  const grouped = groupBy(membersWithSections, (dt) => dt.section);
  return (
    <ButtonDropdown
      items={memberMenu(onClick, grouped, intl)}
      {...buttonProps}
    />
  );
};

MemberDropdown.propTypes = {
  onClick: PropTypes.func.isRequired,
  availableMembers: PropTypes.array.isRequired,
};

export default MemberDropdown;
